import { Flex, Divider } from "@chakra-ui/react";
import ContentTag from "../ContentTag/index";
import DescricaoConta from "./../DescricaoConta/index";
import CardDefault from "components/Cards/CardDefault";
import { ContaItemResponse } from "core/features/conta/typings";
import ContentRight from "./../ContentRight/index";
import { Checkbox } from "antd";
import { showSuccess, showConfirm2 } from "infra/helpers/alerta";
import { showError } from "infra/helpers/alerta";
import ActionsKebabMenu from "ui/components/ActionsKebabMenu";
import { OperacaoEnum } from "core/resources/enums/conta";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { GiReceiveMoney } from "react-icons/gi";
import {
  MdCancel,
  MdCheck,
  MdDelete,
  MdEdit,
  MdMail,
  MdPreview,
  MdRefresh,
} from "react-icons/md";

interface ItemContaProps {
  item: ContaItemResponse;
  selected: boolean;
  refresh: any;
  indexItem: number | undefined;
  showActions?: boolean;
  operacao: OperacaoEnum | undefined;
  onSelect: () => any;
  onUnselect: () => any;
  onRowClick?: (id: string, ev: React.MouseEvent<HTMLDivElement>) => void;
  onEdit: (id: string) => void;
  onLiquidar: (ids: string[]) => void;
  onEstornar?: (id: string) => void;
  onViewHistory?: (id: string) => void;
  onViewHistoryProtesto?: (id: string) => void;
  handleDelete: (ids: string[]) => Promise<void>;
  handleCancelarCobranca: (ids: string[]) => Promise<void>;
  handleReprocessarConta: (variables: string[], options?: any) => void;
  reenviarConta: (variables: string[], options?: any) => void;
}

export default function ItemConta({
  item,
  indexItem,
  showActions = true,
  operacao,
  onSelect,
  onUnselect,
  selected,
  onEdit,
  onLiquidar,
  onEstornar,
  onViewHistory,
  onViewHistoryProtesto,
  handleDelete,
  handleCancelarCobranca,
  handleReprocessarConta,
  reenviarConta,
  refresh,
  onRowClick,
}: ItemContaProps) {
  return (
    <CardDefault
      mb={6}
      px={3}
      py={0}
      cursor="pointer"
      onClick={(ev) => {
        onRowClick!(item.id, ev);
      }}
    >
      <Flex>
        <Flex flex={0.1} py={5}>
          <Checkbox
            checked={selected}
            onChange={() => (selected ? onUnselect() : onSelect())}
            onClick={(ev) => ev.stopPropagation()}
          />
        </Flex>
        <Flex flexDirection="column" flex={4} py={4}>
          <DescricaoConta item={item} operacao={operacao} />
          <Divider />
          <ContentTag item={item} operacao={operacao} />
        </Flex>
        <Flex mx={4}>
          <Divider orientation="vertical" />
        </Flex>
        <Flex flex={1} py={6}>
          <ContentRight item={item} />
        </Flex>
        <Flex h="fit-content" py={4}>
          <ActionsKebabMenu
            indexItem={indexItem}
            item={item}
            actions={
              showActions
                ? [
                    {
                      title: "Editar",
                      permission:
                        operacao === OperacaoEnum.Despesa
                          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar
                              .Editar
                          : PermissaoEnum.Backoffice.Financeiro.ContasReceber
                              .Editar,
                      icon: () => <MdEdit />,
                      onClick: (v) => onEdit(v.id),
                    },
                    {
                      title: (v) =>
                        v.dataPagamento ? "Cancelar Liquidação" : "Liquidar",
                      icon: () => <MdCheck />,
                      onClick: (v) => {
                        if (!v.dataPagamento) {
                          onLiquidar([v.id]);
                        } else {
                          showConfirm2({
                            message: "Deseja realmente estornar esta conta?",
                            onOk: () => onEstornar?.(v.id),
                          });
                        }
                      },
                    },
                    {
                      title: "Ver histórico",
                      icon: () => <MdPreview />,
                      permission:
                        operacao === OperacaoEnum.Despesa
                          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar
                              .Visualizar
                          : PermissaoEnum.Backoffice.Financeiro.ContasReceber
                              .Visualizar,
                      onClick: (v) => {
                        onViewHistory?.(v.id);
                      },
                    },
                    {
                      title: "Ver histórico de protesto",
                      icon: () => <GiReceiveMoney />,
                      shouldRender: (v) => !!v.contaProtestoId,
                      permission:
                        operacao === OperacaoEnum.Despesa
                          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar
                              .Visualizar
                          : PermissaoEnum.Backoffice.Financeiro.ContasReceber
                              .Visualizar,
                      onClick: (v) => {
                        onViewHistoryProtesto?.(v.id);
                      },
                    },
                    {
                      title: "Reenviar email",
                      invisible: operacao === OperacaoEnum.Despesa,
                      icon: () => <MdMail />,
                      permission:
                        operacao === OperacaoEnum.Despesa
                          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar
                              .Visualizar
                          : PermissaoEnum.Backoffice.Financeiro.ContasReceber
                              .Visualizar,
                      onClick: (v) => {
                        if (!v.linkBoleto) {
                          showError("Esta conta não possui boleto!");
                          return;
                        }
                        reenviarConta([v.id], {
                          onSuccess: () => {
                            showSuccess("Conta reenviada com sucesso!");
                          },
                        });
                      },
                    },
                    {
                      title: "Recriar boleto",
                      invisible: operacao === OperacaoEnum.Despesa,
                      icon: () => <MdRefresh />,
                      permission:
                        operacao === OperacaoEnum.Despesa
                          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar
                              .Visualizar
                          : PermissaoEnum.Backoffice.Financeiro.ContasReceber
                              .Visualizar,
                      onClick: (v) => {
                        handleReprocessarConta([v.id], {
                          onSuccess: async () => {
                            await showSuccess("Boleto recriado com sucesso!");
                            refresh();
                          },
                        });
                      },
                    },
                    {
                      title: "Cancelar Cobrança",
                      invisible: operacao === OperacaoEnum.Despesa,
                      icon: () => <MdCancel />,
                      shouldRender: (v) => !v.dataPagamento,
                      permission:
                        PermissaoEnum.Backoffice.Financeiro.ContasReceber
                          .Excluir,
                      onClick: (v) => handleCancelarCobranca([v.id]),
                    },
                    {
                      title: "Excluir",
                      icon: () => <MdDelete />,
                      permission:
                        operacao === OperacaoEnum.Despesa
                          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar
                              .Excluir
                          : PermissaoEnum.Backoffice.Financeiro.ContasReceber
                              .Excluir,
                      onClick: (v) => handleDelete([v.id]),
                    },
                  ]
                : []
            }
          />
        </Flex>
      </Flex>
    </CardDefault>
  );
}
